import { STATE_DROPDOWN_OPTIONS } from '@givelify/utils';

export const getStateName = (state: string | undefined): string => {
    if (!state) return '';
    const st = STATE_DROPDOWN_OPTIONS.find((x) => x.id === state);
    if (st) return st.label;
    return state;
};
